import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import App from './App/index'
import store from './Store'
// rxjs needed for mergeMap to be found on redux-observable
import 'rxjs'

import 'bootstrap/dist/css/bootstrap.css'
import './adminlte/dist/css/AdminLTE.min.css'
import './adminlte/dist/css/skins/_all-skins.min.css'

import './index.css'

if (document.getElementById('common-ui-root')) {
    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>,
        document.getElementById('common-ui-root')
    );
}

